const S = "6c6ec421e43ff64692cb";
var p;
const d = typeof process < "u" && ((p = process.env) == null ? void 0 : p.NODE_ENV) === "development";
typeof window < "u" && (window._cio = window._cio || []);
const n = {
  FIRST_APP: "ha_first_app",
  FIRST_APP_AT: "ha_first_app_at",
  APPS_USED: "ha_apps_used",
  LAST_APP: "ha_last_app",
  LAST_APP_AT: "ha_last_app_at",
  UTM_SOURCE: "ha_utm_source",
  UTM_MEDIUM: "ha_utm_medium",
  UTM_CAMPAIGN: "ha_utm_campaign",
  REFERRER: "ha_referrer"
};
function E() {
  if (typeof window > "u") return {};
  const e = localStorage.getItem(n.APPS_USED);
  return {
    first_app: localStorage.getItem(n.FIRST_APP),
    first_app_at: localStorage.getItem(n.FIRST_APP_AT),
    apps_used: e ? JSON.parse(e) : [],
    apps_used_count: e ? JSON.parse(e).length : 0,
    last_app: localStorage.getItem(n.LAST_APP),
    last_app_at: localStorage.getItem(n.LAST_APP_AT),
    signup_utm_source: localStorage.getItem(n.UTM_SOURCE),
    signup_utm_medium: localStorage.getItem(n.UTM_MEDIUM),
    signup_utm_campaign: localStorage.getItem(n.UTM_CAMPAIGN),
    signup_referrer: localStorage.getItem(n.REFERRER)
  };
}
function A(e) {
  if (typeof window > "u") return { isFirstVisit: !1, appsUsed: [] };
  const t = new URLSearchParams(window.location.search);
  t.get("utm_source") && !localStorage.getItem(n.UTM_SOURCE) && (localStorage.setItem(n.UTM_SOURCE, t.get("utm_source") || ""), localStorage.setItem(n.UTM_MEDIUM, t.get("utm_medium") || ""), localStorage.setItem(n.UTM_CAMPAIGN, t.get("utm_campaign") || "")), document.referrer && !localStorage.getItem(n.REFERRER) && localStorage.setItem(n.REFERRER, document.referrer);
  const s = !localStorage.getItem(n.FIRST_APP);
  s && (localStorage.setItem(n.FIRST_APP, e), localStorage.setItem(n.FIRST_APP_AT, (/* @__PURE__ */ new Date()).toISOString()));
  const _ = JSON.parse(localStorage.getItem(n.APPS_USED) || "[]");
  return _.includes(e) || (_.push(e), localStorage.setItem(n.APPS_USED, JSON.stringify(_))), localStorage.setItem(n.LAST_APP, e), localStorage.setItem(n.LAST_APP_AT, (/* @__PURE__ */ new Date()).toISOString()), a.track(`${e}_visited`, {
    first_visit: s,
    referrer: document.referrer,
    url: window.location.href,
    utm_source: t.get("utm_source"),
    utm_medium: t.get("utm_medium"),
    utm_campaign: t.get("utm_campaign")
  }), d && console.log(`[Analytics] App tracking: ${e}`, { isFirstVisit: s, appsUsed: _ }), { isFirstVisit: s, appsUsed: _ };
}
const a = {
  /**
   * Identify a user - call after login/signup
   */
  identify(e, t = {}) {
    if (typeof window > "u") return;
    const o = E();
    window._cio.push(["identify", {
      id: e,
      ...o,
      ...t,
      last_seen_at: (/* @__PURE__ */ new Date()).toISOString()
    }]), d && console.log("[Analytics] Identified:", e, { ...o, ...t });
  },
  /**
   * Track an event
   */
  track(e, t = {}) {
    typeof window > "u" || (window._cio.push(["track", e, {
      ...t,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    }]), d && console.log("[Analytics] Track:", e, t));
  },
  /**
   * Track a page view
   */
  page(e, t = {}) {
    typeof window > "u" || window._cio.push(["page", e || document.title, {
      url: window.location.href,
      path: window.location.pathname,
      referrer: document.referrer,
      ...t
    }]);
  },
  /**
   * Reset/clear the current user (call on logout)
   */
  reset() {
    typeof window > "u" || (window._cio.push(["reset"]), d && console.log("[Analytics] User reset"));
  },
  /**
   * Update user attributes
   */
  update(e) {
    typeof window > "u" || window._cio.push(["identify", e]);
  }
};
let l = !1;
function D(e = {}) {
  var _;
  if (typeof window > "u" || l) return;
  const { router: t, appName: o, disableInDev: s = !1 } = e;
  if (s && d) {
    console.log("[Analytics] Disabled in development");
    return;
  }
  if (!document.getElementById("cio-tracker")) {
    const i = document.createElement("script");
    i.id = "cio-tracker", i.async = !0, i.setAttribute("data-site-id", S), i.src = "https://assets.customer.io/assets/track.js";
    const c = document.getElementsByTagName("script")[0];
    (_ = c == null ? void 0 : c.parentNode) == null || _.insertBefore(i, c);
  }
  o && A(o), t && t.afterEach((i) => {
    var c, u;
    a.page(((c = i.name) == null ? void 0 : c.toString()) || i.path, {
      app: o,
      route_name: (u = i.name) == null ? void 0 : u.toString(),
      route_path: i.path
    });
  }), l = !0, d && console.log("[Analytics] Initialized", { appName: o, hasRouter: !!t });
}
function T() {
  return {
    identify: a.identify,
    track: a.track,
    page: a.page,
    reset: a.reset,
    update: a.update,
    getAttribution: E
  };
}
const r = {
  // Auth
  SIGNED_IN: "signed_in",
  SIGNED_UP: "signed_up",
  SIGNED_OUT: "signed_out",
  // App Usage
  APP_OPENED: "app_opened",
  CREDITS_USED: "credits_used",
  CREDITS_PURCHASED: "credits_purchased",
  // Subscription
  SUBSCRIPTION_STARTED: "subscription_started",
  SUBSCRIPTION_CANCELLED: "subscription_cancelled",
  SUBSCRIPTION_UPGRADED: "subscription_upgraded",
  // VidSabio
  VIDEO_UPLOADED: "video_uploaded",
  COURSE_CREATED: "course_created",
  COURSE_PUBLISHED: "course_published",
  COURSE_EXPORTED: "course_exported",
  // AI Media
  IMAGE_GENERATED: "image_generated",
  IMAGE_EDITED: "image_edited",
  AUDIO_GENERATED: "audio_generated",
  MEDIA_DOWNLOADED: "media_downloaded",
  // EchoCast
  COURSE_CONNECTED: "course_connected",
  UPDATE_PUSHED: "update_pushed",
  LEARNER_NOTIFIED: "learner_notified",
  // Course Translator
  COURSE_UPLOADED: "course_uploaded",
  TRANSLATION_STARTED: "translation_started",
  TRANSLATION_COMPLETED: "translation_completed",
  TRANSLATION_DOWNLOADED: "translation_downloaded",
  COURSE_TRANSLATED: "course_translated",
  // Course Extractor
  COURSE_EXTRACTED: "course_extracted",
  EXTRACTION_EXPORTED: "extraction_exported",
  // Storyboard2Rise
  STORYBOARD_UPLOADED: "storyboard_uploaded",
  RISE_GENERATED: "rise_generated",
  RISE_EXPORTED: "rise_exported",
  // Course Rebrander
  REBRANDING_STARTED: "rebranding_started",
  REBRANDING_COMPLETED: "rebranding_completed"
}, g = {
  // Auth events
  signedIn: (e = "password") => {
    a.track(r.SIGNED_IN, { method: e, ...E() });
  },
  signedUp: (e = "password") => {
    a.track(r.SIGNED_UP, { method: e, ...E() });
  },
  signedOut: () => {
    a.track(r.SIGNED_OUT), a.reset();
  },
  // Credits & Subscription
  creditsPurchased: (e, t, o) => {
    a.track(r.CREDITS_PURCHASED, { amount: e, price: t, package_name: o });
  },
  creditsUsed: (e, t, o) => {
    a.track(r.CREDITS_USED, { amount: e, action: t, app: o });
  },
  subscriptionStarted: (e, t, o) => {
    a.track(r.SUBSCRIPTION_STARTED, { plan: e, interval: t, price: o });
  },
  subscriptionCancelled: (e, t) => {
    a.track(r.SUBSCRIPTION_CANCELLED, { plan: e, reason: t });
  },
  // VidSabio
  videoUploaded: (e, t) => {
    a.track(r.VIDEO_UPLOADED, {
      duration_seconds: e,
      file_size_mb: t
    });
  },
  courseCreated: (e, t, o) => {
    a.track(r.COURSE_CREATED, {
      chapter_count: e,
      has_quiz: t,
      source: o
    });
  },
  coursePublished: (e) => {
    a.track(r.COURSE_PUBLISHED, { course_id: e });
  },
  courseExported: (e) => {
    a.track(r.COURSE_EXPORTED, { format: e });
  },
  // AI Media
  imageGenerated: (e, t, o) => {
    a.track(r.IMAGE_GENERATED, { model: e, style: t, prompt_length: o });
  },
  audioGenerated: (e, t) => {
    a.track(r.AUDIO_GENERATED, { voice: e, duration_seconds: t });
  },
  mediaDownloaded: (e) => {
    a.track(r.MEDIA_DOWNLOADED, { type: e });
  },
  // Storyboard2Rise
  storyboardUploaded: (e, t) => {
    a.track(r.STORYBOARD_UPLOADED, { format: e, page_count: t });
  },
  riseGenerated: (e) => {
    a.track(r.RISE_GENERATED, { block_count: e });
  },
  // Course Translator
  translationStarted: (e, t, o) => {
    a.track(r.TRANSLATION_STARTED, {
      source_lang: e,
      target_lang: t,
      word_count: o
    });
  },
  translationCompleted: (e, t) => {
    a.track(r.TRANSLATION_COMPLETED, {
      word_count: e,
      credits_used: t
    });
  },
  courseTranslated: (e, t) => {
    a.track(r.COURSE_TRANSLATED, {
      language_count: e,
      word_count: t
    });
  },
  // Course Extractor
  courseExtracted: (e, t) => {
    a.track(r.COURSE_EXTRACTED, { format: e, slide_count: t });
  },
  extractionExported: (e) => {
    a.track(r.EXTRACTION_EXPORTED, { export_format: e });
  },
  // EchoCast
  courseConnected: (e) => {
    a.track(r.COURSE_CONNECTED, { lms_type: e });
  },
  updatePushed: (e, t) => {
    a.track(r.UPDATE_PUSHED, { course_id: e, update_type: t });
  },
  // Course Rebrander
  rebrandingStarted: (e) => {
    a.track(r.REBRANDING_STARTED, { course_type: e });
  },
  rebrandingCompleted: (e) => {
    a.track(r.REBRANDING_COMPLETED, { changes_count: e });
  }
};
function R(e, t, o) {
  const s = E();
  a.identify(e, {
    ...t,
    ...s,
    last_app_used: o || s.last_app
  });
}
export {
  r as Events,
  a as analytics,
  a as default,
  E as getAttribution,
  R as identifyUser,
  D as initAnalytics,
  A as initAppTracking,
  g as trackEvent,
  T as useAnalytics
};
